import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-1 fixed left-4 right-4 top-4 z-50 m-auto" }
const _hoisted_2 = ["onClick"]

import { useNotifications } from '@/composables/useNotifications'
interface IPropsTheNotifications {
    name?: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    name: { type: String, required: false, default: 'default' }
  },
  setup(__props: any) {

const props = __props as { name: string }
const { notifications, removeNotification } = useNotifications()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "list",
      tag: "article",
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "transform scale-90 opacity-0",
      "enter-to-class": "transform scale-100 opacity-100",
      "leave-active-class": "transition duration-75 ease-in",
      "leave-from-class": "transform scale-100 opacity-100",
      "leave-to-class": "transform scale-90 opacity-0"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notification, id) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `notification${id}`
          }, [
            (props.name === '' || notification.slot === props.name)
              ? (_openBlock(), _createElementBlock("article", {
                  key: 0,
                  class: _normalizeClass(["bg-white shadow-menu py-3 px-5 mb-2 font-basier text-white font-medium text-base select-none", {
                        'bg-green': notification.type === 'success',
                        'bg-red': notification.type === 'fail',
                    }]),
                  onClick: ($event: any) => (_unref(removeNotification)(notification.id))
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(notification.content), 1)
                  ])
                ], 10, _hoisted_2))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})